/**
 * BHCR Product Card — Add to Cart handler
 * Uses data attributes on the button for i18n strings.
 */
(function () {
  if (window.__bhcrProductCardATC) return;
  window.__bhcrProductCardATC = true;

  function getLabelEl(btn) {
    return btn.querySelector('.product-card__cta-label') || btn;
  }

  function setLabel(btn, text) {
    getLabelEl(btn).textContent = text;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card__add-to-cart');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var labelAdd = btn.dataset.labelAdd || (window.productCardStrings && window.productCardStrings.add) || '';
    var labelAdding = btn.dataset.labelAdding || (window.productCardStrings && window.productCardStrings.adding) || '';
    var labelAdded = btn.dataset.labelAdded || (window.productCardStrings && window.productCardStrings.added) || '';
    var labelError = btn.dataset.labelError || (window.productCardStrings && window.productCardStrings.error) || '';

    setLabel(btn, labelAdding);
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    function resetButton(delay) {
      setTimeout(function () {
        setLabel(btn, labelAdd);
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }, delay);
    }

    var cartDrawer = document.querySelector('cart-drawer');
    var addBody = {
      items: [{ id: parseInt(variantId, 10), quantity: 1 }],
    };
    if (cartDrawer) {
      addBody.sections =
        (window.BhcrCartPricing &&
          BhcrCartPricing.getCartSectionApiKeys({ includeFooter: true }).join(',')) ||
        'cart-drawer';
      addBody.sections_url = window.location.pathname;
    }

    var addRequest = window.BhcrCart
      ? window.BhcrCart.add(addBody)
      : fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(addBody),
        }).then(function (res) {
          return res.json();
        });

    addRequest
      .then(function (data) {
        if (data.status && data.status >= 400) {
          setLabel(btn, data.description || labelError);
          resetButton(2000);
          return;
        }

        setLabel(btn, labelAdded);

        if (cartDrawer && window.BhcrCart) {
          if (window.BhcrCart.syncCartUI) {
            window.BhcrCart.syncCartUI(data);
          } else {
            window.BhcrCart.syncDrawer(cartDrawer, data);
          }
          cartDrawer.open(btn);
        } else if (cartDrawer && typeof cartDrawer.refresh === 'function') {
          cartDrawer.refresh().then(function () {
            cartDrawer.open(btn);
          });
        }
        resetButton(1500);
      })
      .catch(function (err) {
        if (typeof console !== 'undefined' && console.error) {
          console.error('Add to cart failed:', err);
        }
        var rateMsg = window.cartStrings && window.cartStrings.rateLimit;
        setLabel(btn, err && err.message === 'rate_limited' && rateMsg ? rateMsg : labelError);
        resetButton(2000);
      });
  });
})();
